import axios, { AxiosRequestConfig } from 'axios';
import _ from 'lodash';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import { LogInInfo } from 'bff/models/login';

const instance = axios.create({
  baseURL: '/FakeData'
});

instance.interceptors.request.use(function (config:AxiosRequestConfig) {
  // config.headers.Authorization = 'AUTH_TOKEN';
  config = handleAttachToken(config);

  return config;
},
function (error) {
  return Promise.reject(error);
});

/**
 * @description 如果有 token 於 Request header 中加入
*/
const handleAttachToken = (config:AxiosRequestConfig) => {
  const passUrl:string[] = ['/login', '/captcha'];

  // 如果為不需加入的呼叫就跳過
  if (_.some(passUrl, (str:string) => config.url?.indexOf(str) !== -1)) return config;

  let accessToken = '';
  if (storageService.getItem(storageKeys.LoginInfo)) {
    const loginInfo = JSON.parse(storageService.getItem(storageKeys.LoginInfo)) as LogInInfo;
    accessToken = loginInfo.access_token;
  }

  // 有 token 就修改 header
  if (accessToken) {
    return {
      ...config,
      headers: {
        ...config.headers,
        Authorization: `Bearer ${accessToken}`
      }
    };
  }

  return config;
};

axios.interceptors.response.use(
  function (response) {
    // console.log('response', response);
    return response;
  }
);

export default instance;
